export default class ManufacturerChannelContent {
    initialize() {
        this._brandAlertControls();
        this._controlBrandAlertsNavigation();
        this._controlFeaturedContentNavigation();
        this._showAllVideos();
    }

    _brandAlertControls() {
        const indicationHeaders = document.querySelectorAll('.js_indicationsHeader');
        const isiHeaders = document.querySelectorAll('.js_infoHeader');

        indicationHeaders.forEach((header) => {
            header.addEventListener('touchmove', (e) => e.preventDefault());
            header.addEventListener('click', () =>
                this._toggleIndicationsInformation(header.closest('.js_secondaryWrap')),
            );
        });

        isiHeaders.forEach((header) => {
            header.addEventListener('touchmove', (e) => e.preventDefault());
            header.addEventListener('click', () => this._toggleSafetyInformation(header.closest('.js_secondaryWrap')));
        });
    }

    _toggleIndicationsInformation(indicationsWrap) {
        indicationsWrap.classList.toggle('indications-expanded');
        indicationsWrap.classList.remove('safety-expanded');
    }

    _toggleSafetyInformation(isiWrap) {
        isiWrap.classList.toggle('safety-expanded');
        isiWrap.classList.remove('indications-expanded');
    }

    _controlBrandAlertsNavigation() {
        const brandAlertGroups = Array.from(document.querySelectorAll('.js_brandAlertGroup'));

        if (!brandAlertGroups.length) return;

        const updateButtonStates = (list, nextButton, prevButton) => {
            const maxScrollLeft = list.scrollWidth - list.clientWidth;

            // Check if scrolling is necessary
            if (list.scrollWidth <= list.clientWidth) {
                // Disable (hide) all navigation buttons as scrolling is not needed
                nextButton.setAttribute('disabled', true);
                prevButton.setAttribute('disabled', true);
            } else {
                // Enable or disable buttons based on the current position
                nextButton.removeAttribute('disabled');
                prevButton.removeAttribute('disabled');

                if (list.scrollLeft >= maxScrollLeft) {
                    nextButton.classList.add('is-disabled');
                    prevButton.classList.remove('is-disabled');
                } else if (list.scrollLeft === 0) {
                    prevButton.classList.add('is-disabled');
                    nextButton.classList.remove('is-disabled');
                } else {
                    nextButton.classList.remove('is-disabled');
                    prevButton.classList.remove('is-disabled');
                }
            }
        };

        brandAlertGroups.forEach((brandAlertGroup) => {
            const navigationButtons = Array.from(brandAlertGroup.querySelectorAll('.js_brandAlertNavigationBtn'));
            const nextButton = brandAlertGroup.querySelector('.js_brandAlertNavigationBtn.is-next');
            const prevButton = brandAlertGroup.querySelector('.js_brandAlertNavigationBtn.is-previous');
            const brandAlert = brandAlertGroup.querySelector('.js_popupFrame');
            const list = brandAlertGroup.querySelector('.js_brandAlertsList');
            let counter = 0;

            if (!list) return;

            if (list.scrollWidth > list.clientWidth) {
                navigationButtons.forEach((button) => {
                    button.removeAttribute('disabled');
                });
            }

            navigationButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    const listStyles = window.getComputedStyle(list);
                    const listColumnGap = parseInt(listStyles.getPropertyValue('column-gap'), 10);
                    counter = button.classList.contains('is-previous') ? counter - 1 : counter + 1;
                    list.scroll({ left: (brandAlert.clientWidth + listColumnGap) * counter, behavior: 'smooth' });

                    setTimeout(() => {
                        updateButtonStates(list, nextButton, prevButton);
                    }, 500);
                });
            });
        });

        window.addEventListener('resize', () => {
            // Update button states when the browser window is resized
            brandAlertGroups.forEach((brandAlertGroup) => {
                const nextButton = brandAlertGroup.querySelector('.js_brandAlertNavigationBtn.is-next');
                const prevButton = brandAlertGroup.querySelector('.js_brandAlertNavigationBtn.is-previous');
                const list = brandAlertGroup.querySelector('.js_brandAlertsList');
                updateButtonStates(list, nextButton, prevButton);
            });
        });
    }

    _controlFeaturedContentNavigation() {
        const navigationButtons = Array.from(document.querySelectorAll('.js_featuredContentNavigationBtn'));
        const nextButton = document.querySelector('.js_featuredContentNavigationBtn.is-next');
        const prevButton = document.querySelector('.js_featuredContentNavigationBtn.is-previous');
        const list = document.querySelector('.js_featuredContentList');
        let counter = 0;

        if (!list) {
            return;
        }

        if (list.scrollWidth > list.clientWidth) {
            navigationButtons.forEach((button) => {
                button.removeAttribute('disabled');
            });
        }

        const updateButtonStates = () => {
            const maxScrollLeft = list.scrollWidth - list.clientWidth;

            // Check if scrolling is necessary
            if (list.scrollWidth <= list.clientWidth) {
                // Disable (hide) all navigation buttons as scrolling is not needed
                navigationButtons.forEach((button) => button.setAttribute('disabled', true));
            } else {
                // Enable or disable buttons based on the current position
                navigationButtons.forEach((button) => button.removeAttribute('disabled'));

                if (list.scrollLeft >= maxScrollLeft) {
                    nextButton.classList.add('is-disabled');
                    prevButton.classList.remove('is-disabled');
                } else if (list.scrollLeft === 0) {
                    prevButton.classList.add('is-disabled');
                    nextButton.classList.remove('is-disabled');
                } else {
                    nextButton.classList.remove('is-disabled');
                    prevButton.classList.remove('is-disabled');
                }
            }
        };

        navigationButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const listStyles = window.getComputedStyle(list);
                const listColumnGap = parseInt(listStyles.getPropertyValue('column-gap'), 10);
                const listWidth = parseInt(listStyles.getPropertyValue('width'), 10);
                const listItemWidth = Math.ceil((listWidth - listColumnGap * 2) / 3); // 2 gaps = card [gap] card [gap] card
                counter = button.classList.contains('is-previous') ? counter - 1 : counter + 1;
                list.scroll({ left: (listItemWidth + listColumnGap) * counter, behavior: 'smooth' });

                setTimeout(() => {
                    updateButtonStates();
                }, 500);
            });
        });

        window.addEventListener('resize', () => {
            // Update button states when the browser window is resized
            updateButtonStates();
        });
    }

    _showAllVideos() {
        const buttons = Array.from(document.querySelectorAll('.js_showAllVideosButton'));

        if (!buttons.length) return;

        const allVideosButtonClickHandler = (button) => {
            const list = button.previousElementSibling;
            list.classList.add('show-all-videos');
            button.remove();
        };
        if (buttons.length === 1) {
            // When there is only one expandable row, expand it immediately
            allVideosButtonClickHandler(buttons[0]);
        } else {
            buttons.forEach((button) => {
                button.addEventListener('click', () => allVideosButtonClickHandler(button));
            });
        }
    }
}

const instance = new ManufacturerChannelContent();
instance.initialize();
